import styled from '@emotion/styled';
import { t } from 'services/translation';
import { AnyRoadLogoGrayFooter2023 } from 'views/anyguide/layout/logo/images/AnyRoadLogoGrayFooter2023';
import { colors } from 'ui_system/compass';

const Bullet = styled.span`
  color: ${colors.text.icon};
  font-size: clamp(8px, 2vw, 10px);
  margin: 0 clamp(4px, 1vw, 8px);
`;

const PoweredByContainer = styled.p`
  .top-border {
    border: 0;
    border-top: 1px solid #e6e6e6;
    margin-bottom: clamp(12px, 3vw, 18px);
    width: clamp(50px, 15vw, 70px);
  }
`;

const Logo = styled(AnyRoadLogoGrayFooter2023)`
  width: clamp(120px, 25vw, 200px);
  max-width: 100%;
  height: auto;
  fill: #898c9a;
`;

const TermsLinksContainer = styled.div`
  margin-top: clamp(6px, 1.5vw, 8px);
  margin-bottom: clamp(20px, 8vw, 50px);
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: clamp(4px, 1vw, 8px);
`;

const TermsLink = styled.a`
  color: #6e6e6e;
  font-size: clamp(10px, 2.5vw, 12px);
  text-decoration: underline;
  min-height: 44px;
  display: flex;
  align-items: center;

  &:focus {
    outline: 1px solid ${colors.text.link};
  }

  &:hover {
    color: ${colors.text.link};
  }
`;

interface PoweredByProps {
  hidePolicyLinks?: boolean;
}

export const PoweredBy = ({ hidePolicyLinks = false }: PoweredByProps) => {
  const link = (
    linkDestination: string,
    linkText: string,
    ariaLabel?: string
  ) => {
    return (
      <TermsLink
        className="terms-link"
        target="_blank"
        rel="noopener noreferrer"
        href={linkDestination}
        aria-label={ariaLabel}
      >
        {linkText}
      </TermsLink>
    );
  };

  return (
    <PoweredByContainer
      className="powered-by-container"
      data-testid="powered-by"
    >
      <a
        aria-label="Anyroad logo - link to Anyroad.com homepage"
        className="logo-link"
        target="_blank"
        rel="noopener noreferrer"
        href="https://www.anyroad.com/"
      >
        <Logo />
      </a>
      {!hidePolicyLinks && (
        <TermsLinksContainer>
          {link(
            'https://www.anyroad.com/end-user-terms',
            t('TERMS_OF_SERVICE'),
            `Read Anyroad's ${t('TERMS_OF_SERVICE')} - opens in new tab`
          )}
          <Bullet aria-hidden="true">●</Bullet>
          {link(
            'https://www.anyroad.com/privacy',
            t('PRIVACY_POLICY'),
            `Read Anyroad's ${t('PRIVACY_POLICY')} - opens in new tab`
          )}
        </TermsLinksContainer>
      )}
    </PoweredByContainer>
  );
};
